module.exports = "<div class=\"spinner-icon\"><i class=\"icon-loading animate-spin\"></i></div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/spinner.component.html
// module id = 960
// module chunks = 0